import { createStore } from '@stencil/store';

import { IStatusStore } from '../type/status.type';

// If needed we can add 'reset', 'onChange'...Check stencil-store doc
export const {
  state: StatusStore,
  onChange,
  reset: resetStatusStore,
} = createStore<IStatusStore>({
  userStatuses: {},
});
